import Team3 from './Team3'
export default Team3
